import Dragger from 'antd/es/upload/Dragger';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../../../store/loading/actions';
import * as XLSX from 'xlsx';
import { Form } from 'antd';
import { Button } from 'antd';
import { Row } from 'antd';

import { UploadOutlined, VerticalAlignBottomOutlined } from '@ant-design/icons';
import { CustomerType } from '../../../../../services/apisType';

const excelFileAccept = '.xls, .xlsx';

const uploadProps = {
  name: 'file',
  multiple: false,
  accept: excelFileAccept,
};

export const EXCEL_TEMPLATE_URL =
  'https://bona-pos.s3.us-east-2.amazonaws.com/template6fab9062-c722-4576-8964-48b9498d0db8.xlsx';

const UploadCustomers = () => {
  const form = Form.useFormInstance();
  const dispatch = useDispatch();

  const handleBeforeUpload = (file: File) => {
    dispatch(setLoading(true));
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>): void => {
      const data = e.target?.result;
      if (data) {
        const workbook = XLSX.read(data as string, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });
        const newLstCustomer: CustomerType[] = excelData
          .slice(1)
          .filter((row: any) => !!row[0])
          .map((row: any) => {
            return {
              customerId: '',
              customerName: row[0], // Assuming the name is in the second column (index 1)
              customerPhone: row[1], // Assuming the phone is in the third column (index 2)
              email: row[2] === '' ? '' : row[2], // Assuming the point is in the fifth column (index 4)
              birthday: row[3] === '' ? '' : row[3],
              point: row[4] === '' ? 0 : row[4],
              lastVisitedDate: row[5] === '' ? '' : row[5],
              amountSpent: row[6] === '' ? 0 : row[6],
            };
          });
        form.setFieldsValue({ customers: newLstCustomer });
      }
    };
    reader.readAsBinaryString(file);
    dispatch(setLoading(false));
    return false;
  };

  const onDownloadTemplate = () => {
    //@ts-ignore
    window?.open(EXCEL_TEMPLATE_URL, '_blank')?.focus();
  };

  const onRemove = () => {
    form.setFieldsValue({ customers: [] });
  };

  return (
    <div>
      <Form.Item name='campaignCustomerSelectFile'>
        <Dragger
          {...uploadProps}
          beforeUpload={handleBeforeUpload}
          maxCount={1}
          onRemove={onRemove}
          name='campaignCustomerSelectFile'
        >
          <p className='ant-upload-drag-icon'>
            <UploadOutlined />
          </p>
          <p className='ant-upload-text'>Upload file customer</p>
          <div style={{ position: 'absolute', top: 8, right: 8 }}>
            <Button
              type='text'
              onClick={(e) => [e.stopPropagation(), onDownloadTemplate()]}
              className='btn-download'
            >
              <Row align={'middle'} style={{ gap: 4 }}>
                <VerticalAlignBottomOutlined style={{ fontSize: 20 }} />
                <span>Download template</span>
              </Row>
            </Button>
          </div>
        </Dragger>
      </Form.Item>
    </div>
  );
};

export default UploadCustomers;
